import isEqual from 'lodash/isEqual';

export const defaultZustandCompareFunction = <T>(prevData: T, newData: T): boolean => isEqual(prevData, newData);
